import {
  LOAD_PREMIUM_PRICING,
  LOAD_PREMIUM_PRICING_ERROR,
} from "../actions/types";

const initialState = {
  loading: true,
  employerId: null,
  errors: {},
};

export default function premiumPricingReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_PREMIUM_PRICING:
      return {
        ...state,
        loading: false,
        employerId: payload.employerId,
        employerMembership: payload.employerMembership,
        errors: {},
      };
    case LOAD_PREMIUM_PRICING_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    default:
      return state;
  }
}
